import { MonacoTabs } from "@/zapi-admin/shared/components/MonacoTabs/ui/MonacoTabs";
import { getDataMapFromPromptGraph } from "../../../lib/promptGraphData";
import { TPromptGraphData, TPromptGraphJoinNode, TPromptNode } from "../../../model/promptGraphTypes";

type TNodeDataViewerProps = {
  node: TPromptGraphJoinNode;
  setNode: (n: TPromptNode<string> | null) => void;
  promptGraphData: TPromptGraphData<string>;
};

export function NodeDataViewer({ node, setNode, promptGraphData }: TNodeDataViewerProps) {
  if (!node) return null;
  const isFunctionNode = !("prompt" in node);
  const { prompt, executionResult, result, ...rest } = node as TPromptGraphJoinNode & {
    prompt: string;
    executionResult: string;
  };
  const { dataMap, execMap } = getDataMapFromPromptGraph(promptGraphData);
  return (
    <div onClick={() => setNode(null)} className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-start">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-r-lg w-full max-w-6xl p-4 max-h-screen h-screen overflow-y-auto transition-transform duration-300 transform translate-x-0"
      >
        <div className="h-[calc(100vh-100px)]">
          <MonacoTabs
            files={
              isFunctionNode
                ? [{ id: "Result", label: "Result (Function output)", value: result || "" }]
                : [
                    { id: "Execution Result", label: "Execution Result (AI Response)", value: executionResult || "" },
                    { id: "Result", label: "Result (Final prompt used)", value: result || "" },
                    { id: "Prompt", label: "Prompt (Prompt template)", value: prompt || "", language: "innSnip" },
                    { id: "Node Data", label: "Node Data", value: JSON.stringify(rest, null, 2) }
                  ]
            }
            dataMap={dataMap}
            execMap={execMap}
          />
        </div>
      </div>
    </div>
  );
}
